import { useCallback, useState } from "react";
import { Outlet } from "react-router";
import type { WeekReading } from "@/lib/api/models/week";

/**
 * What the steps share that is not the draft: the previewed week, and the
 * email a code was sent to. Both live for one visit only. A reload at the
 * reveal asks again, and the server returns the same week for the same chart.
 */
export interface OnboardingSharedState {
  readonly week: WeekReading | null;
  readonly setWeek: (week: WeekReading | null) => void;
  readonly email: string;
  readonly setEmail: (email: string) => void;
}

export function OnboardingLayout() {
  const [week, setWeekState] = useState<WeekReading | null>(null);
  const [email, setEmailState] = useState("");
  const setWeek = useCallback((next: WeekReading | null) => setWeekState(next), []);
  const setEmail = useCallback((next: string) => setEmailState(next), []);
  const shared: OnboardingSharedState = { week, setWeek, email, setEmail };
  return <Outlet context={shared} />;
}
